import { render, staticRenderFns } from "./PositionField.vue?vue&type=template&id=8daf5598"
import script from "./PositionField.vue?vue&type=script&lang=js"
export * from "./PositionField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports